import { render, staticRenderFns } from "./CourseByBuy.vue?vue&type=template&id=651d879a&scoped=true&"
import script from "./CourseByBuy.vue?vue&type=script&lang=js&"
export * from "./CourseByBuy.vue?vue&type=script&lang=js&"
import style0 from "./CourseByBuy.vue?vue&type=style&index=0&id=651d879a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d879a",
  null
  
)

export default component.exports